import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { Base64UploadComponent } from './Base64Upload.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'CargueMasivoTerceros',
        component: Base64UploadComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CargueMasivoTerceros',
          nombreFormulario : 'Cargue Masivo Terceros'
        } 
    }
];

@NgModule({
    declarations: [
        Base64UploadComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        Base64UploadComponent
    ],
    bootstrap: [Base64UploadComponent]
})

export class Base64UploadModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CargueTercerosMasivos/Base64Upload.module.ts